import { ColorProps } from '@chakra-ui/react';
import { Box, BoxProps, Paragraph } from '../../../../atoms';

export type StatusTagVariant = 'success' | 'warning';

export type CardStatusTagProps = {
  children?: string;
  variant: StatusTagVariant;
  /**
   * In most cases we want to place this tag in the top right corner
   *  of the card and not effect the size of the card. In some cases this pushes the content of the card down.
   *
   * @default false
   */
  positionedRelative?: boolean;
} & BoxProps;

const variantStyle: {
  [type in StatusTagVariant]: { backgroundColor: ColorProps['color'] };
} = {
  success: {
    backgroundColor: 'palette_success.50'
  },
  warning: {
    backgroundColor: 'palette_warning.50'
  }
};

export function CardStatusTag({
  children,
  positionedRelative = false,
  variant,
  ...rest
}: CardStatusTagProps): JSX.Element {
  return (
    <Box
      backgroundColor={variantStyle[variant].backgroundColor}
      paddingX="20px"
      paddingY="4px"
      borderBottomLeftRadius="radii.x2"
      textAlign="center"
      position={positionedRelative ? 'relative' : 'absolute'}
      {...(!positionedRelative && {
        top: '0',
        right: '0',
        zIndex: '1'
      })}
      {...rest}
    >
      <Paragraph color="palette_white" weight="semiBold" size="sm">
        {children}
      </Paragraph>
    </Box>
  );
}
